<!-- 捐赠推荐项目
捐赠指数页面点击推荐项目下的更多的时候 跳转到该页面
我的捐赠页面点击区捐赠跳转到该页面-->
<template>
  <div class="recommendDiv">
    <van-list :immediate-check="false" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="recommend" v-for="item in donation" :key="item.id" @click="gotoDonationDetail(item.id)">
        <div class="recommendImgDiv">
          <div
            class="recommendTipDiv"
            v-if="item.id % 2 == 0"
            style="background: linear-gradient(-90deg, #01716F, #01716F)"
          >
            <div class="recommendTipWord">{{ item.typeName }}</div>
          </div>
          <div class="recommendTipDiv" v-else style="background: linear-gradient(-90deg, #00706E, #00706E)">
            <div class="recommendTipWord">{{ item.typeName }}</div>
          </div>
          <img :src="item.images" alt="项目图片" class="recommendImg" />
          <!-- <div class="supportNumDiv">
            <div class="supportNum">支持人数 {{ item.persons }} 人</div>
          </div> -->
        </div>
        <div class="recommendCardDiv clearfix">
          <div class="recommendName">{{ item.title }}</div>
          <div class="recommendState" v-if="item.status == 3">未开始</div>
          <div class="recommendState" v-else-if="item.status == 1">进行中</div>
          <div class="recommendState" v-else>已结束</div>
          <div class="maxMoney">目标金额：￥{{ item.targetAmount }}元</div>
          <!-- <div class="nowMoney">已筹金额：￥{{ item.hasAmount }}元</div>
          <div class="percentageDiv clearfix">
            <div class="percentageWord">捐款进度</div>
            <van-progress
              :percentage="(item.hasAmount / item.targetAmount) * 100 || 0"
              stroke-width="15"
              :show-pivot="false"
              class="percentage"
            />
            <div class="percentageNum" v-if="item.targetAmount == 0">
              {{ 0 + '%' }}
            </div>
            <div class="percentageNum" v-else>
              {{ ((item.hasAmount / item.targetAmount) * 100 + '').substring(0, 3) + '%' }}
            </div>
          </div> -->
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      donation: [],
      loading: false,
      finished: false,
      lastPage: '',
      postList: {
        page: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getDonationList();
  },
  methods: {
    async getDonationList() {
      const result = await this.$http.get('/donates/getDonates', {
        params: { currentPage: this.postList.page, perpage: this.postList.pageSize },
      });
      for (let i = 0; i < result.data.list.length; i++) {
        this.donation.push(result.data.list[i]);
      }
      this.lastPage = result.data.lastPage;
    },
    // 懒加载
    onLoad() {
      this.postList.page = this.postList.page + 1;
      this.getDonationList();
      this.loading = false;
      // 数据全部加载完成
      if (this.postList.page >= this.lastPage) {
        this.finished = true;
      }
    },
    gotoDonationDetail(id) {
      return this.$router.push({
        path: '/donationDetail',
        query: { id: id },
      });

    },
  },
};
</script>
<style lang="less" scoped>
.recommendDiv {
  padding-top: 20px;
  position: relative;
}

.recommend {
  position: relative;
  left: 5%;
  width: 90%;
  margin: 0px 0px 20px 0px;
  border-radius: 15px;
  border: 0.04px solid #e1e1e1;
}

.recommendImgDiv {
  position: relative;
  width: 100%;
  height: 20vh;
}

.recommendImg {
  width: 100%;
  height: 100%;
  border-radius: 15px 15px 0 0;
}

.recommendTipDiv {
  position: absolute;
  left: 0%;
  top: 0%;
  width: 35%;
  height: 25px;
  line-height: 25px;
  border-radius: 15px 0px 15px 0px;
}

.recommendTipWord {
  color: white;
  white-space: nowrap;
  text-align: center;
}

.recommendTip {
  width: 100%;
}

.supportNumDiv {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #000000;
  opacity: 0.7;
}

.supportNum {
  float: right;
  color: white;
  padding: 5px 10px 5px 0px;
}

.recommendCardDiv {
  background-color: white;
  border-radius: 0px 0px 15px 15px;
}

.recommendName {
  float: left;
  width: 80%;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px 0px 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.recommendState {
  float: right;
  width: 14%;
  color: #00706E;
  font-size: 1rem;
  font-weight: bold;
  padding: 5px 5px 5px 0px;
}

.maxMoney {
  float: left;
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 50%;
  font-size: 0.9rem;
}

.nowMoney {
  float: right;
  color: #666666;
  margin: 5px 0px 5px 0px;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 0.9rem;
}

.percentageDiv {
  float: left;
  width: 100%;
  margin-bottom: 10px;
}

.percentageWord {
  float: left;
  color: #666666;
  padding: 5px 0px 5px 10px;
  font-size: 0.9rem;
}

.percentage {
  float: left;
  width: 60%;
  margin: 5px 0px 5px 10px;
}

.percentageNum {
  float: right;
  color: #666666;
  padding: 5px 10px 5px 0px;
}

.clearfix:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/DonationList.vue